import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Button } from '@src/elements/button/button'
import { Tabs, Tab } from '@src/components/tabs/tabs'
import { TicketModal } from '@src/routes/support/components/exercises/ticket-modal'
import { ExerciseSupportTicket } from '@src/data/support-ticket'

enum ContentType {
  CONTACT = 'contact',
  SUPPORT_TICKET = 'support-ticket'
}

@Component
export class Support extends Vue {

  private showAddTicketModal: boolean = false

  constructor () {
    super()
  }

  selectTab (type: ContentType | string) {
    if (type === ContentType.SUPPORT_TICKET) {
      this.$router.push(`/trainers/platform/support/support-ticket/draft`)
    } else {
      this.$router.push(`/trainers/platform/support/${type}`)
    }
  }

  isTabSelected (type: ContentType) {
    let pathParts = this.$route.path.split('/')
    if (type === ContentType.CONTACT && (pathParts[pathParts.length - 1] === 'contact-support' || pathParts[pathParts.length - 1] === ContentType.CONTACT)) {
      return true
    } else if (type === ContentType.SUPPORT_TICKET && (pathParts[pathParts.length - 2] === ContentType.SUPPORT_TICKET || pathParts[pathParts.length - 1] === ContentType.SUPPORT_TICKET)) {
      return true
    }
    return false
  }

  addNewExerciseTicket () {
    this.showAddTicketModal = !this.showAddTicketModal
  }

  render (h: CreateElement) {
    return <div class='support'>
      <div class='component-tabs-wrapper'><Tabs>
        <Tab label={this.$t('SUPPORT_PAGE.CONTACT_SUPPORT')} selected={this.isTabSelected(ContentType.CONTACT)}
             selectTab={() => this.selectTab(ContentType.CONTACT)} />
        <Tab label={this.$t('SUPPORT_PAGE.SUPPORT_TICKET.TITLE')} selected={this.isTabSelected(ContentType.SUPPORT_TICKET)}
             selectTab={() => this.selectTab(ContentType.SUPPORT_TICKET)} />
        {this.isTabSelected(ContentType.SUPPORT_TICKET) ?
          <Button type='elevated' class='add-new-ticket' label={this.$t('SUPPORT_PAGE.SUPPORT_TICKET.ADD')} click={this.addNewExerciseTicket} /> : null}
      </Tabs>
        <div class='component-tabs-body'>
          <router-view />
        </div>
      </div>
      {this.showAddTicketModal ? <TicketModal action='add' supportTicket={new ExerciseSupportTicket()} closeCallback={this.addNewExerciseTicket} /> : null}
    </div>
  }
}
